export default __webpack_public_path__ + "static/media/Back.ddb17d90.svg";